import React from 'react';
import clinicData from '../data/clinicData.json';

const Appointment = () => {
  return (
    <div className="bg-gradient-to-br from-cream to-sage overflow-auto">
      {/* Header */}
      <div className="bg-white shadow-md">
        <div className="max-w-6xl mx-auto px-4 py-6">
          <h1 className="text-2xl sm:text-3xl font-bold gradient-text text-center">Book Your Appointment</h1>
          <p className="text-gray-600 text-center mt-2">Schedule your consultation with Dr. Vrushali Ghate</p>
        </div>
      </div>

      {/* Appointment Information */}
      <div className="py-8 px-4">
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-2xl shadow-2xl p-6 sm:p-8">
            <div className="text-center mb-8">
              <p className="text-lg text-gray-600 mb-6">Welcome! We provide comprehensive homoeopathic treatment and psychological counselling services. Choose your preferred consultation method below.</p>
            </div>
            
            <h3 className="text-2xl font-bold gradient-text text-center mb-8">Appointment Timings</h3>
            
            <div className="grid md:grid-cols-2 gap-8">
              {/* Online Appointments */}
              <div className="bg-gradient-to-br from-sage to-cream p-6 rounded-xl border border-gray-200">
                <div className="flex items-center mb-4">
                  <span className="material-icons text-forest text-2xl mr-3">videocam</span>
                  <h4 className="text-xl font-semibold text-gray-800">Online Consultation</h4>
                </div>
                <div className="space-y-3 mb-6">
                  <div className="flex items-center">
                    <span className="material-icons text-olive mr-2">schedule</span>
                    <span className="text-gray-700">10:00 AM - 11:00 AM (IST)</span>
                  </div>
                  <div className="flex items-center">
                    <span className="material-icons text-olive mr-2">schedule</span>
                    <span className="text-gray-700">2:00 PM - 3:00 PM (IST)</span>
                  </div>
                  <div className="flex items-center mt-4">
                    <span className="material-icons text-sage mr-2">computer</span>
                    <span className="text-gray-600 text-sm">Via Google Meet</span>
                  </div>
                </div>
                <a href="/appointment/online" className="block w-full bg-gradient-to-r from-forest to-olive text-white py-3 px-6 rounded-lg font-semibold hover:from-olive hover:to-forest transition-all duration-300 shadow-md hover:shadow-lg text-center">
                  Book Online
                </a>
              </div>
              
              {/* Offline Appointments */}
              <div className="bg-gradient-to-br from-sage to-cream p-6 rounded-xl border border-gray-200">
                <div className="flex items-center mb-4">
                  <span className="material-icons text-forest text-2xl mr-3">location_on</span>
                  <h4 className="text-xl font-semibold text-gray-800">Clinic Visit</h4>
                </div>
                <div className="space-y-3 mb-6">
                  <div className="flex items-center">
                    <span className="material-icons text-olive mr-2">schedule</span>
                    <span className="text-gray-700">11:00 AM - 2:00 PM (IST)</span>
                  </div>
                  <div className="flex items-center">
                    <span className="material-icons text-olive mr-2">schedule</span>
                    <span className="text-gray-700">6:00 PM - 7:30 PM (IST)</span>
                  </div>
                  <div className="flex items-center mt-4">
                    <span className="material-icons text-sage mr-2">business</span>
                    <span className="text-gray-600 text-sm">At Clinic</span>
                  </div>
                </div>
                <div className="flex gap-2">
                  <a href={`tel:+91${clinicData.contact.phone}`} className="flex-1 bg-gradient-to-r from-forest to-olive text-white py-3 px-4 rounded-lg font-semibold hover:from-olive hover:to-forest transition-all duration-300 shadow-md hover:shadow-lg text-center">
                    Call
                  </a>
                  <a href={`https://wa.me/91${clinicData.contact.phone}?text=${clinicData.contact.message}`} className="flex-1 bg-gradient-to-r from-forest to-olive text-white py-3 px-4 rounded-lg font-semibold hover:from-olive hover:to-forest transition-all duration-300 shadow-md hover:shadow-lg text-center">
                    Message
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Contact Info */}
      <div className="py-8 px-4">
        <div className="max-w-4xl mx-auto text-center">
          <div className="bg-white/90 backdrop-blur-sm p-6 rounded-xl shadow-lg">
            <h3 className="text-xl font-bold text-gray-800 mb-4">Need Help?</h3>
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <a href={`tel:+91${clinicData.contact.phone}`} className="btn-primary flex items-center gap-2">
                <span className="material-icons">phone</span>
                Call: {clinicData.contact.phone}
              </a>
              <a href={`https://wa.me/91${clinicData.contact.phone}`} className="btn-secondary flex items-center gap-2">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.465 3.516"/>
                </svg>
                WhatsApp
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* WhatsApp Float Button */}
      <a 
        href={`https://wa.me/91${clinicData.contact.phone}?text=${clinicData.contact.message}`}
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 z-50 animate-float"
      >
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.465 3.516"/>
        </svg>
      </a>
    </div>
  );
};

export default Appointment;